import API from '../../../../services/apiService.js'

var api= new API();


export default {

  // Загрузить список категорий заявок
  async loadRequestCategories ({ commit }) {
    var data=null;
    try{
      data = await api.Get("DirectoryService/RequestCategory");
      commit('loadRequestCategories', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

}
